import { useEffect, useRef, useState } from "react";
import type { View } from "react-native";
import { findNodeHandle, UIManager } from "react-native";
import type { TamaguiElement } from "tamagui";

export const useCalculatePopoverPosition = <
  Row extends Record<string, unknown>,
>(
  firstSelectedRow?: Row,
) => {
  const rowRef = useRef<Record<string, TamaguiElement>>({});

  const firstRow = (firstSelectedRow?.id as string)
    ? rowRef?.current[firstSelectedRow?.id as string]
    : null;

  const [popoverPosition, setPopoverPosition] = useState({
    x: 0,
    y: 0,
  });

  useEffect(() => {
    const handle = findNodeHandle(firstRow as unknown as View);
    if (handle) {
      UIManager.measure(handle, (x, y) => {
        setPopoverPosition({
          x,
          y,
        });
        console.log("Screen position:", { x, y });
      });
    }
  }, [firstRow]);

  return { rowRef, popoverPosition };
};
